import { InjectionToken } from "@angular/core";
import { BestCompanyConfig, Company, CompanyAccess } from "@shared/models";

export const COMPANY_LISTENER = new InjectionToken<ICompanyListener>('cwt-company-listener');

export interface ICompanyListener {
    onCompanyActivated(company: Company, access: CompanyAccess, config: BestCompanyConfig): void;
    onCompanyDeactivated(company: Company, access: CompanyAccess, config: BestCompanyConfig): void;
}